export enum AuthErrorCodes {
    USER_ALREADY_EXISTS = 'user_already_exists',
    INVALID_CREDENTIALS = 'invalid_credentials',
    NETWORK_ERROR = 'network_error',
    GENERIC = 'generic',
}

export const HTTP_STATUS_TO_AUTH_ERROR: Record<number, AuthErrorCodes> = {
    409: AuthErrorCodes.USER_ALREADY_EXISTS,
    401: AuthErrorCodes.INVALID_CREDENTIALS,
    403: AuthErrorCodes.INVALID_CREDENTIALS,
    400: AuthErrorCodes.GENERIC,
};
